module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/anchor-095ed1222b123e3f6a8867635f0f6848.svg";